var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 70,
    viewBox: "0 0 85 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H84V1L75 3.5L64 9.5L53 19L41 32L28 45.5L16.5 58.5L10 65L5 68.5H1L0 1V0Z",
    fill: "#0C0F12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 68.5312H4C9.5 66.5 12.8 63.5 16 59.5C19.2 55.5 39 34.6978 50.5 22.5312C57 15.0312 72.9 0.231167 84.5 1.03117",
    stroke: "#3E3E3E",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurve);
export default __webpack_public_path__ + "static/media/curve.43c86a4011cbb13fc5677729eb17aa2c.svg";
export { ForwardRef as ReactComponent };